<template>
    <div class="warp">
        <div class="artdetail-box">
           <div class="artdetail-tit">{{detailTitle}}</div>
        </div>
        <div class="introduction-content" v-html="detailList"></div>
    </div>
</template>
<script>
export default {
     name:'imgtext',
     props:{
        detailList:{
          type:String,
        },
        detailTitle:{
          type:String,
        }
     },
     methods:{
     },
     mounted (){
     }
}
</script>
<style>
.artdetail-box{
  margin-bottom: 20px;
}
.artdetail-tit{
  font-size: 20px;
  font-weight: 800;
  text-transform: uppercase;
}
.artdetail-img{
  text-align: center;
}
.artdetail-content{
  line-height: 1.8rem;
  text-align: left;
  margin: 30px 0;
  font-size: 14px;
}
</style>
